const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

export const getStats = async () => {
  const headers = {};
  const apiKey = localStorage.getItem('api_key');
  if (apiKey) {
    headers['Authorization'] = `Bearer ${apiKey}`;
  }
  try {
    const response = await fetch(`${API_BASE_URL}/stats`, { headers });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching stats:', error);
    return { success: false, error: error.message };
  }
};

export const signup = async (signupData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/signup`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(signupData),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error signing up:', error);
    return { success: false, error: error.message };
  }
};

export const createOrder = async (orderData) => {
  const headers = { 'Content-Type': 'application/json' };
  const apiKey = localStorage.getItem('api_key');
  if (apiKey) {
    headers['Authorization'] = `Bearer ${apiKey}`;
  }
  try {
    const response = await fetch(`${API_BASE_URL}/order`, {
      method: 'POST',
      headers,
      body: JSON.stringify(orderData),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating order:', error);
    return { success: false, error: error.message };
  }
};

export const getEstimate = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/estimate`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching estimate:', error);
    return { success: false, error: error.message };
  }
};

export const getProducts = async () => {
  const headers = {};
  const apiKey = localStorage.getItem('api_key');
  if (apiKey) {
    headers['Authorization'] = `Bearer ${apiKey}`;
  }
  try {
    const response = await fetch(`${API_BASE_URL}/products`, { headers });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching products:', error);
    return { success: false, error: error.message };
  }
};

export const createProduct = async (productData) => {
  const headers = { 'Content-Type': 'application/json' };
  const apiKey = localStorage.getItem('api_key');
  if (apiKey) {
    headers['Authorization'] = `Bearer ${apiKey}`;
  }
  try {
    const response = await fetch(`${API_BASE_URL}/products`, {
      method: 'POST',
      headers,
      body: JSON.stringify(productData),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating product:', error);
    return { success: false, error: error.message };
  }
};

export const updateProduct = async (productId, productData) => {
  const headers = { 'Content-Type': 'application/json' };
  const apiKey = localStorage.getItem('api_key');
  if (apiKey) {
    headers['Authorization'] = `Bearer ${apiKey}`;
  }
  try {
    const response = await fetch(`${API_BASE_URL}/products/${productId}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(productData),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating product:', error);
    return { success: false, error: error.message };
  }
};

export const deleteProduct = async (productId) => {
  const headers = {};
  const apiKey = localStorage.getItem('api_key');
  if (apiKey) {
    headers['Authorization'] = `Bearer ${apiKey}`;
  }
  try {
    const response = await fetch(`${API_BASE_URL}/products/${productId}`, {
      method: 'DELETE',
      headers,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error deleting product:', error);
    return { success: false, error: error.message };
  }
};

export const getAdmin = async () => {
  const headers = {};
  const apiKey = localStorage.getItem('api_key');
  if (apiKey) {
    headers['Authorization'] = `Bearer ${apiKey}`;
  }
  try {
    const response = await fetch(`${API_BASE_URL}/admin`, { headers });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error verifying admin access:', error);
    return { success: false, error: error.message };
  }
};
